import React from 'react';
import { Switch, Route } from 'react-router-dom';

import LoginContainer from './Login/LoginContainer';
import PasswordRecoveryContainer from './PasswordRecovery/PasswordRecoveryContainer'

function Auth() {
    return (
        <div className="container-fluid h-100 LoginContainer">
			<div className="row h-100 justify-content-center align-middle">
				<div className="col-sm-5 d-none d-sm-block d-md-block d-lg-block align-self-center h-100" style={{ background: 'url("images/login-bg.jpg") no-repeat', backgroundSize: 'cover' }}></div>
				<div className="col-sm-7 h-100 align-self-center"  style={{ background: 'white' }}>
					<div className="row h-100">
						<div className="col-sm-10 offset-sm-1 align-middle align-self-center">
                            <Switch>
								<Route path="/password-recovery"  component={PasswordRecoveryContainer} />
								<Route path="/" component={LoginContainer} />
							</Switch>
                        </div>
                    </div>
			    </div>
		    </div>
        </div>
    )
}

export default Auth;